import { type _getLogger } from '@doxyme/analytics';

type Logger = ReturnType<typeof _getLogger>;
type LoggerProps = Record<string, unknown>;

export type LogErrorAndThrow = (
  logger: Logger,
  message: string,
  loggerProps?: LoggerProps,
) => never;
export type LogErrorAndThrowBound = (
  message: string,
  loggerProps?: LoggerProps,
) => never;

/**
 * Util fn to simplify logging and throwing errors.
 */
export const logErrorAndThrow: LogErrorAndThrow = (
  logger: Logger,
  message: string,
  loggerProps?: LoggerProps,
) => {
  logger.error(message, loggerProps);

  throw new Error(message);
};

/**
 * Explicit typing for function returns "never" is required to work properly
 * e.g. https://github.com/microsoft/TypeScript/issues/57594
 *
 * @example
 * ```ts
 * const logErrorAndThrow: LogErrorAndThrowBound = logErrorAndThrowBind(logger);
 * // or
 * const logErrorAndThrow: ReturnType<typeof logErrorAndThrowBind> = logErrorAndThrowBind(logger);
 * ```
 */
export const logErrorAndThrowBind: (logger: Logger) => LogErrorAndThrowBound = (
  logger: Logger,
) => {
  return logErrorAndThrow.bind(null, logger);
};
